import { useState } from "react";

import { C, IG_HANDLE, IMG_LOGO, SHIPPING_ZONES } from "../data/handcraftsConfig";

function detectDeliveryZone(rawLocation) {
  const value = rawLocation.trim().toLowerCase();
  if (!value) return null;

  const metroKeywords = ["san salvador", "santa tecla", "antiguo cuscatlan", "soyapango", "mejicanos", "ilopango"];
  const localKeywords = ["santa ana", "san miguel", "sonsonate", "ahuachapan", "la libertad", "chalatenango", "cuscatlan", "la paz", "la union", "morazan", "san vicente", "cabanas", "usulutan"];
  const usKeywords = ["usa", "united states", "estados unidos", "texas", "california", "maryland", "virginia", "new york", "florida"];
  const pickupKeywords = ["pickup", "recoger", "retiro", "en persona"];

  if (pickupKeywords.some((keyword) => value.includes(keyword))) return "pickup";
  if (metroKeywords.some((keyword) => value.includes(keyword))) return "sv_metro";
  if (localKeywords.some((keyword) => value.includes(keyword))) return "sv_local";
  if (usKeywords.some((keyword) => value.includes(keyword))) return "us";
  if (value.includes("el salvador")) return "sv_local";

  return null;
}

function PaymentResultPage({ orderId, paymentStatus, t }) {
  const isSpanish = typeof t.nav_inicio === "string" && t.nav_inicio.toLowerCase() === "inicio";
  const stateCopy = paymentStatus === "paid"
    ? {
        title: isSpanish ? "Pago confirmado" : "Payment confirmed",
        description: isSpanish ? "Tu pago fue confirmado correctamente. Abu preparara tu pedido." : "Your payment was confirmed successfully. Abu will prepare your order.",
        accent: "#10b981",
      }
    : paymentStatus === "pending_review"
      ? {
          title: isSpanish ? "Pago en revision" : "Payment under review",
          description: isSpanish ? "Recibimos tu intento de pago y estamos esperando la confirmacion final de Wompi." : "We received your payment attempt and are waiting for Wompi's final confirmation.",
          accent: "#f59e0b",
        }
      : {
          title: isSpanish ? "Estamos verificando tu pago" : "We are verifying your payment",
          description: isSpanish ? "Tu pedido ya fue registrado. Si Wompi tarda un poco, esta pagina se actualizara sola." : "Your order has already been registered. If Wompi takes a little longer, this page will update automatically.",
          accent: C.purple,
        };

  return (
    <div style={{maxWidth:900,margin:"0 auto",padding:"52px clamp(16px,5vw,40px) 80px"}}>
      <div style={{background:C.white,borderRadius:28,padding:"40px clamp(22px,4vw,40px)",border:`1.5px solid ${C.paper}`,boxShadow:"0 18px 36px rgba(45,26,46,.08)",textAlign:"center"}}>
        <div style={{width:72,height:72,borderRadius:"50%",background:`${stateCopy.accent}18`,color:stateCopy.accent,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:30,fontWeight:800,marginBottom:18}}>
          {paymentStatus === "paid" ? "OK" : paymentStatus === "pending_review" ? "..." : "?"}
        </div>
        <h1 className="serif" style={{fontSize:"clamp(28px,4vw,42px)",marginBottom:10,color:C.brown}}>{stateCopy.title}</h1>
        <p className="sans" style={{fontSize:15,color:C.brownLt,lineHeight:1.8,maxWidth:620,margin:"0 auto 24px"}}>{stateCopy.description}</p>
        <div style={{background:C.paper,borderRadius:18,padding:"18px 20px",display:"inline-block",minWidth:260}}>
          <div className="sans" style={{fontSize:12,fontWeight:800,color:C.brownLt,marginBottom:6,letterSpacing:"1px",textTransform:"uppercase"}}>
            {isSpanish ? "Numero de pedido" : "Order number"}
          </div>
          <div className="sans" style={{fontSize:24,fontWeight:800,color:C.pink}}>{orderId || "—"}</div>
        </div>
        <div style={{display:"flex",justifyContent:"center",gap:12,flexWrap:"wrap",marginTop:24}}>
          <a href={`https://www.instagram.com/${IG_HANDLE}/`} target="_blank" rel="noreferrer" className="btn btn-purple sans" style={{textDecoration:"none",padding:"13px 24px"}}>
            Instagram @{IG_HANDLE}
          </a>
          <a href="?page=tienda" className="btn btn-outline sans" style={{textDecoration:"none",padding:"13px 24px"}}>
            {isSpanish ? "Seguir comprando" : "Keep shopping"}
          </a>
        </div>
      </div>
    </div>
  );
}

function NavBar({
  count,
  goto,
  handleLogoClick,
  lang,
  menuOpen,
  onCartOpen,
  onCustomOpen,
  onToggleLanguage,
  page,
  setMenuOpen,
  t,
}) {
  return (
    <>
      <header style={{background:C.white,borderBottom:`1.5px solid ${C.paper}`,position:"sticky",top:0,zIndex:50,boxShadow:"0 2px 14px rgba(45,26,46,0.07)"}}>
        <div className="nav-inner" style={{maxWidth:1100,margin:"0 auto",padding:"0 clamp(16px,4vw,40px)",height:68,display:"flex",alignItems:"center",gap:16}}>
          <div className="nav-logo-wrap" style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",flexShrink:0}} onClick={handleLogoClick}>
            <img src={IMG_LOGO} alt="Handcrafts By Abu" style={{height:42,objectFit:"contain"}}/>
            <span style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:"clamp(13px,2vw,18px)",color:"#d94fa0",letterSpacing:"-0.5px",lineHeight:1.1,userSelect:"none"}}>
              Handcrafts<br/><span style={{color:"#4b3f8e"}}>by Abu</span>
            </span>
          </div>
          <nav className="desktop-nav" style={{display:"flex",gap:32,alignItems:"center",flex:1,justifyContent:"center"}}>
            {[["inicio",t.nav_inicio],["tienda",t.nav_tienda],["entrega",t.nav_entrega],["nosotros",t.nav_nosotros]].map(([p,l])=>(
              <button key={p} className={`nav-link${page===p?" active":""}`} onClick={()=>goto(p)}>{l}</button>
            ))}
          </nav>
          <div className="desktop-actions" style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
            <button onClick={onToggleLanguage}
              style={{background:"none",border:`1.5px solid ${C.paper}`,borderRadius:20,padding:"5px 12px",cursor:"pointer",
                fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brownMd,display:"flex",alignItems:"center",gap:5}}>
              {lang==="es"?"US EN":"SV ES"}
            </button>
            <button className="btn btn-outline" style={{fontSize:13,padding:"9px 16px"}} onClick={onCustomOpen}>{t.nav_encargo}</button>
            <button className="btn btn-solid" style={{position:"relative",padding:"9px 18px",fontSize:13}} onClick={onCartOpen}>
              {t.nav_carrito}
              {count>0&&<span style={{position:"absolute",top:-9,right:-9,background:C.purple,color:"#fff",width:22,height:22,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontFamily:"Nunito,sans-serif",fontWeight:800,boxShadow:"0 2px 6px rgba(0,0,0,0.2)"}}>{count}</span>}
            </button>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center",marginLeft:"auto"}} className="mobile-actions">
            <button onClick={onToggleLanguage}
              style={{background:"none",border:`1.5px solid ${C.paper}`,borderRadius:20,padding:"4px 9px",cursor:"pointer",
                fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:800,color:C.brownMd}}>
              {lang==="es"?"US":"SV"}
            </button>
            <button className="btn btn-solid" style={{position:"relative",padding:"9px 14px",fontSize:13}} onClick={onCartOpen}>
              {t.nav_carrito}{count>0&&<span style={{position:"absolute",top:-8,right:-8,background:C.purple,color:"#fff",width:20,height:20,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontFamily:"Nunito,sans-serif",fontWeight:800}}>{count}</span>}
            </button>
            <button className={`hamburger${menuOpen?" open":""}`} onClick={()=>setMenuOpen(m=>!m)} aria-label="Menu">
              <span/><span/><span/>
            </button>
          </div>
        </div>
      </header>
      <div className={`mobile-menu${menuOpen?" open":""}`}>
        {[["inicio",t.nav_inicio_m],["tienda",t.nav_tienda_m],["entrega",t.nav_entrega_m],["nosotros",t.nav_nosotros_m]].map(([p,l])=>(
          <button key={p} className={`mobile-nav-link${page===p?" active":""}`} onClick={()=>goto(p)}>{l}</button>
        ))}
        <div style={{marginTop:24,display:"flex",flexDirection:"column",gap:12}}>
          <button className="btn btn-solid btn-full" style={{fontSize:16,padding:"15px 0"}} onClick={()=>{setMenuOpen(false);onCartOpen();}}>{t.nav_carrito}{count>0&&` (${count})`}</button>
          <button className="btn btn-outline btn-full" style={{fontSize:16,padding:"13px 0"}} onClick={()=>{setMenuOpen(false);onCustomOpen();}}>{t.nav_encargo_m}</button>
          <a href={`https://www.instagram.com/${IG_HANDLE}/`} target="_blank" rel="noreferrer" className="btn btn-purple btn-full sans" style={{fontSize:15,padding:"13px 0",textDecoration:"none",marginTop:4}}>Instagram @{IG_HANDLE}</a>
        </div>
      </div>
    </>
  );
}

function HomePage({
  ProductCard,
  addedId,
  addToCart,
  allProducts,
  goto,
  recentProducts,
  setCheckoutOpen,
  setCustomOpen,
  setDetailItem,
  soldIds,
  t,
}) {
  return (
    <div>
      <section className="hero-section" style={{background:"linear-gradient(150deg,#fdf8fc 0%,#fce4f2 50%,#ede8f8 100%)",paddingTop:"72px",paddingBottom:0,position:"relative",overflow:"hidden"}}>
        <div style={{padding:"0 clamp(16px,5vw,72px) 48px",maxWidth:1100,margin:"0 auto"}}>
          <div style={{maxWidth:600}}>
            <div className="sans" style={{fontSize:11,letterSpacing:"3px",color:C.purple,textTransform:"uppercase",marginBottom:14,fontWeight:800}}>{t.hero_tag}</div>
            <h1 style={{fontSize:"clamp(30px,4vw,52px)",lineHeight:1.1,marginBottom:16,letterSpacing:-1.5}}>
              <em style={{color:C.pink}}>Handcrafts</em><br/>by Abu
            </h1>
            <p className="sans" style={{fontSize:15,color:C.brownMd,marginBottom:10,lineHeight:1.8}}>{t.hero_sub}</p>
            <p className="sans" style={{fontSize:14,color:C.brownLt,marginBottom:30,lineHeight:1.7}}>{t.hero_desc.split("\n").map((l,i)=><span key={i}>{l}{i===0&&<br/>}</span>)}</p>
            <div className="hero-btns" style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:28}}>
              <button className="btn btn-solid" style={{fontSize:15,padding:"14px 30px"}} onClick={()=>goto("tienda")}>{t.hero_btn1}</button>
              <button className="btn btn-outline" style={{fontSize:15,padding:"12px 26px"}} onClick={setCustomOpen}>{t.hero_btn2}</button>
            </div>
            <div className="hero-badges sans" style={{display:"flex",gap:16,flexWrap:"wrap",fontSize:12,color:C.brownLt}}>
              {t.hero_badges.map(b=><span key={b}>{b}</span>)}
            </div>
          </div>
        </div>

        <div style={{width:"100%",overflowX:"auto",paddingBottom:40,paddingLeft:"clamp(16px,5vw,72px)",WebkitOverflowScrolling:"touch",scrollbarWidth:"none",msOverflowStyle:"none"}}>
          <div style={{display:"flex",gap:16,width:"max-content",paddingRight:"clamp(16px,5vw,72px)"}}>
            {allProducts.map((p,i) => {
              const isSoldHero = soldIds && soldIds.includes(p.id);
              const offsets = [0,-22,10,-14,6,-18,8];
              return (
                <div key={p.id} onClick={()=>goto("tienda")} style={{flexShrink:0,width:"clamp(172px,18vw,196px)",borderRadius:24,overflow:"hidden",boxShadow:"0 8px 28px rgba(45,26,46,0.13)",border:"1.5px solid rgba(217,79,160,0.15)",cursor:"pointer",background:C.white,transform:`translateY(${offsets[i%offsets.length]}px)`,transition:"transform .25s,box-shadow .25s",opacity:isSoldHero?0.7:1}}
                  onMouseEnter={e=>{e.currentTarget.style.transform=`translateY(${offsets[i%offsets.length]-8}px)`;e.currentTarget.style.boxShadow="0 16px 40px rgba(217,79,160,0.25)";}}
                  onMouseLeave={e=>{e.currentTarget.style.transform=`translateY(${offsets[i%offsets.length]}px)`;e.currentTarget.style.boxShadow="0 8px 28px rgba(45,26,46,0.13)";}}>
                  <div style={{width:"100%",height:260,background:`linear-gradient(180deg,${C.cream},#fff)`,padding:"14px 14px 10px",boxSizing:"border-box",display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <img src={p.img} alt={p.name} style={{width:"100%",height:"100%",display:"block",objectFit:"contain",objectPosition:"center center"}}/>
                  </div>
                  <div style={{padding:"14px 14px 16px",minHeight:84,display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                    <div style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,lineHeight:1.35,marginBottom:6}}>{p.name}</div>
                    <div style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,color:isSoldHero?"#b0a0a8":C.pink}}>{isSoldHero?t.tienda_sin_stock:"$"+p.price}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section style={{padding:"28px clamp(16px,5vw,64px) 0",maxWidth:1100,margin:"0 auto"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:16}}>
          {[
            { title:"Hecho a mano en El Salvador", desc:"Cada pieza se teje artesanalmente, con acabados pensados para regalo.", accent:C.pink },
            { title:"Pago seguro con Wompi", desc:"Tus clientes pagan con tarjeta, Puntos Agricola o Bitcoin desde una pasarela conocida.", accent:C.purple },
            { title:"Encargos personalizados", desc:"Si no ven exactamente lo que quieren, pueden pedir una version a medida desde la misma web.", accent:C.gold },
          ].map((item) => (
            <div key={item.title} style={{background:C.white,borderRadius:22,padding:"22px 20px",border:`1.5px solid ${C.paper}`,boxShadow:"0 10px 24px rgba(45,26,46,.06)"}}>
              <div style={{width:42,height:4,borderRadius:999,background:item.accent,marginBottom:14}} />
              <h3 style={{fontSize:18,color:C.brown,marginBottom:8}}>{item.title}</h3>
              <p className="sans" style={{fontSize:13,color:C.brownLt,lineHeight:1.7}}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{padding:"72px clamp(16px,5vw,64px)",maxWidth:1100,margin:"0 auto"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <div className="divider">✦ ✦ ✦</div>
          <h2 className="section-title serif">{t.sec_favoritos}</h2>
        </div>
        <div className="products-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:26}}>
          {allProducts.slice(0,3).map(p=><ProductCard key={p.id} p={p} addedId={addedId} onDetail={setDetailItem} soldIds={soldIds} onBuy={p2=>{ if(!soldIds.includes(p2.id)){addToCart(p2);setCheckoutOpen(true);} }}/>)}
        </div>
        <div style={{textAlign:"center",marginTop:36}}>
          <button className="btn btn-solid" style={{fontSize:15,padding:"14px 36px"}} onClick={()=>goto("tienda")}>{t.sec_ver_todo}</button>
        </div>
      </section>

      {recentProducts.length > 0 && (
        <section style={{padding:"0 clamp(16px,5vw,64px) 56px",maxWidth:1100,margin:"0 auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"end",gap:16,marginBottom:24,flexWrap:"wrap"}}>
            <div>
              <div className="divider" style={{textAlign:"left",marginBottom:8}}>✦ ✦ ✦</div>
              <h2 className="section-title serif" style={{marginBottom:6}}>Vistos recientemente</h2>
              <p className="sans" style={{fontSize:13,color:C.brownLt}}>Retoma las piezas que ya te llamaron la atencion.</p>
            </div>
          </div>
          <div className="products-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:24}}>
            {recentProducts.map((p)=><ProductCard key={p.id} p={p} addedId={addedId} onDetail={setDetailItem} soldIds={soldIds} onBuy={p2=>{ if(!soldIds.includes(p2.id)){addToCart(p2);setCheckoutOpen(true);} }}/>)}
          </div>
        </section>
      )}

      <section style={{background:`linear-gradient(135deg,${C.paper},${C.cream})`,padding:"72px clamp(16px,5vw,64px)"}}>
        <div style={{maxWidth:1100,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:40}}>
            <h2 className="section-title serif">{t.sec_como}</h2>
            <div className="divider">✦ ✦ ✦</div>
          </div>
          <div className="steps-wrap" style={{display:"flex",gap:16,flexWrap:"wrap"}}>
            {[
              {n:1,icon:"Cart",t:t.step1_t,d:t.step1_d},
              {n:2,icon:"Pay",t:t.step2_t,d:t.step2_d},
              {n:3,icon:"Crochet",t:t.step3_t,d:t.step3_d},
              {n:4,icon:"Ship",t:t.step4_t,d:t.step4_d},
            ].map(s=>(
              <div key={s.n} className="step-card">
                <div className="step-num">{s.n}</div>
                <div style={{fontSize:20,marginBottom:10,fontWeight:800}}>{s.icon}</div>
                <h4 style={{fontSize:16,marginBottom:8,color:C.brown}}>{s.t}</h4>
                <p className="sans" style={{fontSize:13,color:C.brownLt,lineHeight:1.65}}>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{padding:"0 clamp(16px,5vw,64px) 48px",maxWidth:1100,margin:"0 auto"}}>
        <div className="pay-strip" style={{background:C.white,borderRadius:20,padding:"20px 32px",display:"flex",alignItems:"center",justifyContent:"center",gap:24,flexWrap:"wrap",border:`1.5px solid ${C.paper}`}}>
          <span className="sans" style={{fontSize:13,color:C.brownLt,fontWeight:700}}>{t.sec_pagos}</span>
          <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,background:"linear-gradient(135deg,#5b2d8e,#9b4dca)",borderRadius:12,padding:"7px 14px"}}>
              <span style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,color:"white",letterSpacing:.5}}>Wompi</span>
            </div>
            {["Visa","Mastercard","Puntos Agricola","Bitcoin / Chivo"].map(label => (
              <span key={label} style={{fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:800,padding:"5px 10px",borderRadius:20,background:C.paper,color:C.brownMd,border:`1.5px solid ${C.paper}`}}>
                {label}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section style={{background:`linear-gradient(150deg,${C.purpleLt}33,${C.rose})`,padding:"72px clamp(16px,5vw,64px)"}}>
        <div style={{maxWidth:1100,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:40}}>
            <h2 className="section-title serif">{t.sec_testimonios}</h2>
            <div className="divider">✦ ✦ ✦</div>
          </div>
          <div className="testimonios-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:20}}>
            {t.testimonios.map((r,i)=>(
              <div key={i} style={{background:C.white,borderRadius:20,padding:"24px",border:`1.5px solid ${C.paper}`,boxShadow:"0 4px 16px rgba(45,26,46,0.07)"}}>
                <div style={{display:"flex",gap:2,marginBottom:10}}>{"★★★★★".split("").map((s,j)=><span key={j} style={{color:C.pink,fontSize:16}}>{s}</span>)}</div>
                <p className="sans" style={{fontSize:14,color:C.brownMd,lineHeight:1.75,marginBottom:16}}>{r.text}</p>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,color:C.brown}}>— {r.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{padding:"72px clamp(16px,5vw,64px)",maxWidth:1100,margin:"0 auto",textAlign:"center"}}>
        <div style={{background:`linear-gradient(135deg,${C.purple},${C.pink})`,borderRadius:28,padding:"56px 32px",color:"white"}}>
          <div style={{fontSize:52,marginBottom:16}}>Abu</div>
          <h2 style={{fontFamily:"Playfair Display,serif",fontSize:"clamp(22px,3vw,34px)",marginBottom:14}}>Handcrafts By Abu</h2>
          <p className="sans" style={{fontSize:15,opacity:.9,margin:"0 auto 28px",maxWidth:440,lineHeight:1.7}}>{t.hero_sub}</p>
          <button className="btn btn-white" style={{fontSize:16,padding:"15px 36px"}} onClick={setCustomOpen}>{t.sec_encargo_cta}</button>
        </div>
      </section>

      <footer style={{background:C.brown,color:"rgba(255,255,255,.75)",padding:"48px clamp(16px,5vw,64px) 32px",textAlign:"center"}}>
        <img src={IMG_LOGO} alt="Handcrafts By Abu" style={{height:44,objectFit:"contain",filter:"brightness(0) invert(1)",opacity:.9,marginBottom:20}}/>
        <p className="sans" style={{fontSize:14,marginBottom:8}}>{t.footer_sub}</p>
        <a href={`https://www.instagram.com/${IG_HANDLE}/`} target="_blank" rel="noreferrer" className="sans" style={{color:C.pinkLt,fontWeight:700,fontSize:14,textDecoration:"none"}}>@{IG_HANDLE}</a>
        <p className="sans" style={{fontSize:12,marginTop:20,opacity:.5}}>{t.footer_copy}</p>
      </footer>
    </div>
  );
}

function ShopPage({
  ProductCard,
  addedId,
  addToCart,
  allProducts,
  catFilter,
  lang,
  recentProducts,
  searchQ,
  setCatFilter,
  setCheckoutOpen,
  setCustomOpen,
  setDetailItem,
  setSearchQ,
  setSortBy,
  soldIds,
  sortBy,
  t,
}) {
  const categories = [t.tienda_todos, "Religiosos","Animales","Muñecas"];
  let filtered = allProducts
    .filter(p => catFilter===t.tienda_todos || catFilter==="Todos" || p.cat===catFilter)
    .filter(p => !searchQ || p.name.toLowerCase().includes(searchQ.toLowerCase()));
  if (sortBy==="precio-asc") filtered = [...filtered].sort((a,b)=>a.price-b.price);
  if (sortBy==="precio-desc") filtered = [...filtered].sort((a,b)=>b.price-a.price);
  if (sortBy==="nombre") filtered = [...filtered].sort((a,b)=>a.name.localeCompare(b.name));

  return (
    <div style={{maxWidth:1100,margin:"0 auto",padding:"40px clamp(16px,5vw,40px) 72px"}}>
      <div style={{marginBottom:32}}>
        <h1 className="serif section-title" style={{marginBottom:8}}>{t.tienda_title}</h1>
        <p className="sans" style={{color:C.brownLt,fontSize:15}}>{t.tienda_sub.replace("{n}",allProducts.length)}</p>
      </div>
      <div className="toolbar-wrap" style={{background:C.white,borderRadius:20,padding:"16px 20px",display:"flex",flexWrap:"wrap",gap:12,alignItems:"center",marginBottom:28,border:`1.5px solid ${C.paper}`,boxShadow:"0 2px 10px rgba(45,26,46,.06)"}}>
        <div style={{position:"relative",flexShrink:0,width:"100%",maxWidth:280}}>
          <input className="search-input" placeholder={t.tienda_buscar} value={searchQ} onChange={e=>setSearchQ(e.target.value)} style={{width:"100%"}}/>
        </div>
        <div className="pills-wrap" style={{display:"flex",gap:7,flexWrap:"wrap"}}>
          {categories.map(c=><button key={c} className={`pill${catFilter===c||(!categories.includes(catFilter)&&c===t.tienda_todos)?" active":""}`} onClick={()=>setCatFilter(c)}>{c}</button>)}
        </div>
        <select className="sans" value={sortBy} onChange={e=>setSortBy(e.target.value)} style={{marginLeft:"auto",padding:"9px 14px",borderRadius:50,border:`2px solid ${C.paper}`,background:C.white,color:C.brownMd,fontFamily:"Nunito,sans-serif",fontWeight:700,fontSize:13,cursor:"pointer",outline:"none"}}>
          <option value="default">{lang==="es"?"Ordenar":"Sort"}</option>
          <option value="precio-asc">{lang==="es"?"Precio ↑":"Price ↑"}</option>
          <option value="precio-desc">{lang==="es"?"Precio ↓":"Price ↓"}</option>
          <option value="nombre">{lang==="es"?"Nombre A-Z":"Name A-Z"}</option>
        </select>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,flexWrap:"wrap",marginBottom:22}}>
          <div className="sans" style={{fontSize:13,fontWeight:800,color:C.brown}}>
            {filtered.length} {lang==="es" ? "productos visibles" : "products visible"}
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {[
              lang==="es" ? "Hecho a mano" : "Handmade",
              lang==="es" ? "Pago seguro" : "Secure checkout",
              lang==="es" ? "Envios a SV y exterior" : "SV + international shipping",
            ].map((label) => (
              <span key={label} className="sans" style={{fontSize:11,fontWeight:800,padding:"6px 10px",borderRadius:999,background:C.paper,color:C.brownMd}}>
                {label}
              </span>
            ))}
          </div>
        </div>
        {filtered.length===0?(
          <div style={{textAlign:"center",padding:"60px 0",color:C.brownLt}}>
            <div style={{fontSize:48,marginBottom:12}}>No items</div>
            <p className="sans" style={{fontSize:16}}>{lang==="es"?"No se encontraron productos":"No products found"}</p>
          </div>
        ):(
          <div className="products-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(268px,1fr))",gap:26}}>
            {filtered.map(p=><ProductCard key={p.id} p={p} addedId={addedId} onDetail={setDetailItem} soldIds={soldIds} onBuy={p2=>{ if(!soldIds.includes(p2.id)){addToCart(p2);setCheckoutOpen(true);} }}/>)}
          </div>
        )}
        {recentProducts.length > 0 && (
          <div style={{marginTop:28}}>
            <h3 style={{fontSize:22,color:C.brown,marginBottom:8}}>You may also like</h3>
            <p className="sans" style={{fontSize:13,color:C.brownLt,marginBottom:18}}>Basado en lo que has visto recientemente.</p>
            <div className="products-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:20}}>
              {recentProducts.map((p)=><ProductCard key={`recent-${p.id}`} p={p} addedId={addedId} onDetail={setDetailItem} soldIds={soldIds} onBuy={p2=>{ if(!soldIds.includes(p2.id)){addToCart(p2);setCheckoutOpen(true);} }}/>)}
            </div>
          </div>
        )}
        <div style={{marginTop:28,background:C.white,borderRadius:22,padding:"22px 24px",border:`1.5px solid ${C.paper}`,display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:16,boxShadow:"0 8px 20px rgba(45,26,46,.05)"}}>
          {[
            { title:lang==="es"?"Compra con confianza":"Shop with confidence", desc:lang==="es"?"Las piezas solo se marcan agotadas despues de confirmarse el pago." :"Items only switch to sold after payment confirmation." },
              { title:lang==="es"?"Entrega clara":"Delivery made clear", desc:lang==="es"?"Revisa la pagina de Entrega para estimados en El Salvador y Estados Unidos." :"Use the Delivery page to check shipping estimates for El Salvador and the U.S." },
            { title:lang==="es"?"No ves tu idea?":"Need something custom?", desc:lang==="es"?"Abu tambien recibe encargos a medida con referencias e ideas personalizadas." :"Abu also accepts custom orders with references and tailored ideas." },
          ].map((item) => (
            <div key={item.title}>
              <h3 style={{fontSize:17,color:C.brown,marginBottom:8}}>{item.title}</h3>
              <p className="sans" style={{fontSize:13,color:C.brownLt,lineHeight:1.7}}>{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="bottom-cta" style={{marginTop:64,background:`linear-gradient(135deg,${C.rose},${C.paper})`,borderRadius:24,padding:"36px 40px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:20,border:`1.5px solid ${C.pink}33`}}>
          <div>
            <h3 style={{fontSize:22,marginBottom:6}}>{t.tienda_encargo_cta}</h3>
            <p className="sans" style={{fontSize:14,color:C.brownLt}}>{t.tienda_encargo_sub}</p>
        </div>
        <button className="btn btn-solid" style={{fontSize:15,padding:"14px 28px"}} onClick={setCustomOpen}>{t.tienda_encargo_btn}</button>
      </div>
    </div>
  );
}

function AboutPage({ goto, openFaq, setCustomOpen, setOpenFaq, t }) {
  return (
    <div>
      <section className="nosotros-hero" style={{background:`linear-gradient(155deg,${C.paper},${C.purpleLt}44)`,padding:"72px clamp(16px,5vw,72px) 80px",textAlign:"center"}}>
        <div className="divider">✦ ✦ ✦</div>
        <h1 className="serif" style={{fontSize:"clamp(28px,4vw,46px)",marginBottom:16}}>{t.nos_title}</h1>
        <p className="sans" style={{fontSize:16,color:C.brownMd,maxWidth:600,margin:"0 auto",lineHeight:1.8}}>{t.nos_sub}</p>
      </section>
      <section style={{padding:"72px clamp(16px,5vw,64px)",maxWidth:1100,margin:"0 auto"}}>
        <div className="about-grid" style={{display:"grid",gridTemplateColumns:"auto 1fr",gap:44,alignItems:"center",background:C.white,borderRadius:28,padding:"44px 48px",border:`1.5px solid ${C.paper}`,boxShadow:"0 4px 20px rgba(45,26,46,.08)"}}>
          <div style={{width:140,height:140,borderRadius:"50%",background:`linear-gradient(135deg,${C.rose},${C.paper})`,border:`4px solid ${C.pink}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:48,fontWeight:800,flexShrink:0}}>Abu</div>
          <div>
            <h2 style={{fontSize:26,marginBottom:14,color:C.brown}}>{t.nos_hola}</h2>
            <p className="sans" style={{fontSize:15,color:C.brownMd,lineHeight:1.85,marginBottom:12}}>{t.nos_bio1}</p>
            <p className="sans" style={{fontSize:15,color:C.brownMd,lineHeight:1.85,marginBottom:20}}>{t.nos_bio2}</p>
            <a href={`https://www.instagram.com/${IG_HANDLE}/`} target="_blank" rel="noreferrer" className="btn btn-purple sans" style={{textDecoration:"none",display:"inline-flex",padding:"11px 24px",fontSize:14}}>{t.nos_ig}</a>
          </div>
        </div>
      </section>
      <section style={{background:`linear-gradient(135deg,${C.paper},${C.cream})`,padding:"72px clamp(16px,5vw,64px)"}}>
        <div style={{maxWidth:1100,margin:"0 auto"}}>
          <h2 className="section-title serif" style={{textAlign:"center",marginBottom:10}}>{t.nos_valores}</h2>
          <div className="divider">✦ ✦ ✦</div>
          <div className="values-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:20,marginTop:28}}>
            {t.valores.map((v,i)=>(
              <div key={i} className="value-card">
                <div style={{fontSize:28,marginBottom:12,fontWeight:800}}>{v.icon}</div>
                <h4 style={{fontSize:17,marginBottom:8,color:C.brown}}>{v.t}</h4>
                <p className="sans" style={{fontSize:13,color:C.brownLt,lineHeight:1.65}}>{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section style={{padding:"72px clamp(16px,5vw,64px)",maxWidth:1100,margin:"0 auto"}}>
        <h2 className="section-title serif" style={{textAlign:"center",marginBottom:10}}>{t.nos_proceso}</h2>
        <div className="divider">✦ ✦ ✦</div>
        <div className="steps-wrap" style={{display:"flex",gap:16,flexWrap:"wrap",marginTop:28}}>
          {t.proceso.map(s=>(
            <div key={s.n} className="step-card">
              <div className="step-num">{s.n}</div>
              <div style={{fontSize:24,marginBottom:10,fontWeight:800}}>{s.icon}</div>
              <h4 style={{fontSize:16,marginBottom:8,color:C.brown}}>{s.t}</h4>
              <p className="sans" style={{fontSize:13,color:C.brownLt,lineHeight:1.65}}>{s.d}</p>
            </div>
          ))}
        </div>
      </section>
      <section style={{padding:"0 clamp(16px,5vw,64px) 72px",maxWidth:1100,margin:"0 auto"}}>
        <div style={{background:`linear-gradient(135deg,${C.purple},${C.pink})`,borderRadius:28,padding:"48px",textAlign:"center",color:"white"}}>
          <h2 style={{fontFamily:"Playfair Display,serif",fontSize:"clamp(22px,3vw,32px)",marginBottom:14}}>{t.nos_cta_title}</h2>
          <p className="sans" style={{fontSize:14,opacity:.9,marginBottom:24}}>{t.nos_cta_sub}</p>
          <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
            <button className="btn btn-white" style={{fontSize:15,padding:"13px 28px"}} onClick={()=>goto("tienda")}>{t.nos_cta_btn1}</button>
            <button className="btn btn-white" style={{fontSize:15,padding:"13px 28px"}} onClick={setCustomOpen}>{t.nos_cta_btn2}</button>
          </div>
        </div>
      </section>
      <section style={{padding:"0 clamp(16px,5vw,64px) 72px",maxWidth:1100,margin:"0 auto"}}>
        <h2 className="section-title serif" style={{marginBottom:28,textAlign:"center"}}>{t.nos_faq_title}</h2>
        {t.faqs.map(([q,a],i)=>(
          <div key={i} className="faq-item">
            <button className="faq-q" onClick={()=>setOpenFaq(openFaq===i?null:i)}>
              {q} <span style={{fontSize:20,color:C.pink,transition:"transform .2s",transform:openFaq===i?"rotate(45deg)":"rotate(0deg)"}}>+</span>
            </button>
            <div className={`faq-a${openFaq===i?" open":""}`}>{a}</div>
          </div>
        ))}
      </section>
      <footer style={{background:C.brown,color:"rgba(255,255,255,.75)",padding:"48px clamp(16px,5vw,64px) 32px",textAlign:"center"}}>
        <img src={IMG_LOGO} alt="Handcrafts By Abu" style={{height:44,objectFit:"contain",filter:"brightness(0) invert(1)",opacity:.9,marginBottom:20}}/>
        <p className="sans" style={{fontSize:14,marginBottom:8}}>{t.footer_sub}</p>
        <a href={`https://www.instagram.com/${IG_HANDLE}/`} target="_blank" rel="noreferrer" className="sans" style={{color:C.pinkLt,fontWeight:700,fontSize:14,textDecoration:"none"}}>@{IG_HANDLE}</a>
        <p className="sans" style={{fontSize:12,marginTop:20,opacity:.5}}>{t.footer_copy}</p>
      </footer>
    </div>
  );
}

function DeliveryPage({ t }) {
  const [location, setLocation] = useState("");
  const zoneId = detectDeliveryZone(location);
  const matchedZone = SHIPPING_ZONES.find((zone) => zone.id === zoneId) || null;
  const isSpanish = typeof t.nav_inicio === "string" && t.nav_inicio.toLowerCase() === "inicio";
  const copy = {
    title: t.delivery_title || (isSpanish ? "Entrega y Zonas" : "Delivery and Zones"),
    sub: t.delivery_sub || (isSpanish ? "Consulta tiempos, costos y la zona de entrega que aplica a tu pedido." : "Check delivery times, prices, and the shipping zone for your order."),
    lookupLabel: t.delivery_lookup_label || (isSpanish ? "Tu ciudad, departamento o pais" : "Your city, state, or country"),
    lookupPlaceholder: t.delivery_lookup_placeholder || (isSpanish ? "Ej: San Salvador, Santa Ana, Estados Unidos" : "Example: San Salvador, Santa Ana, United States"),
    lookupButton: t.delivery_lookup_button || (isSpanish ? "Reconocer zona" : "Find my zone"),
    lookupEmpty: t.delivery_lookup_empty || (isSpanish ? "Escribe tu ubicacion para ver la zona recomendada." : "Type your location to see the recommended zone."),
    lookupResult: t.delivery_lookup_result || (isSpanish ? "Zona recomendada" : "Recommended zone"),
    lookupFallback: t.delivery_lookup_fallback || (isSpanish ? "No encontramos una zona exacta. Abu puede confirmarla por Instagram." : "We could not match an exact zone yet. Abu can confirm it on Instagram."),
    howTitle: t.delivery_how_title || (isSpanish ? "Como funciona la entrega" : "How delivery works"),
    howSteps: Array.isArray(t.delivery_how_steps) && t.delivery_how_steps.length > 0
      ? t.delivery_how_steps
      : isSpanish
        ? [
            "Haz tu pedido desde la tienda o por encargo.",
            "Abu confirma la zona y el costo final de entrega.",
            "Recibes tu pieza por envio o pickup segun la zona.",
          ]
        : [
            "Place your order from the shop or as a custom order.",
            "Abu confirms the shipping zone and final delivery cost.",
            "Receive your piece by shipping or pickup depending on the zone.",
          ],
    pickupNote: t.delivery_pickup_note || (isSpanish ? "Tambien puedes coordinar entrega en persona si prefieres pickup." : "You can also coordinate in-person pickup if you prefer."),
  };

  return (
    <div style={{maxWidth:1100,margin:"0 auto",padding:"40px clamp(16px,5vw,40px) 72px"}}>
      <div style={{marginBottom:32}}>
        <h1 className="serif section-title" style={{marginBottom:8}}>{copy.title}</h1>
        <p className="sans" style={{color:C.brownLt,fontSize:15,lineHeight:1.7}}>{copy.sub}</p>
      </div>

      <div style={{background:C.white,borderRadius:24,padding:"24px",border:`1.5px solid ${C.paper}`,boxShadow:"0 2px 12px rgba(45,26,46,.06)",marginBottom:28}}>
        <label className="sans" style={{display:"block",fontSize:13,fontWeight:800,color:C.brown,marginBottom:8}}>{copy.lookupLabel}</label>
        <input
          value={location}
          onChange={(event) => setLocation(event.target.value)}
          placeholder={copy.lookupPlaceholder}
          style={{width:"100%",padding:"13px 16px",borderRadius:16,border:`2px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:14,outline:"none",boxSizing:"border-box"}}
        />
        <div style={{marginTop:14,background:matchedZone ? C.rose : C.paper,borderRadius:16,padding:"16px 18px"}}>
          <div className="sans" style={{fontSize:12,fontWeight:800,color:C.brownLt,marginBottom:6}}>
            {matchedZone ? copy.lookupResult : copy.lookupButton}
          </div>
          {location.trim() === "" && (
            <div className="sans" style={{fontSize:14,color:C.brownMd}}>{copy.lookupEmpty}</div>
          )}
          {location.trim() !== "" && matchedZone && (
            <div>
              <div style={{fontSize:20,fontWeight:800,color:C.pink,marginBottom:4}}>{matchedZone.label}</div>
              <div className="sans" style={{fontSize:14,color:C.brownMd}}>Entrega estimada: {matchedZone.days}</div>
              <div className="sans" style={{fontSize:14,color:C.brownMd}}>
                Costo base: {matchedZone.displayPrice || (matchedZone.price === 0 ? "Gratis" : `$${matchedZone.price}`)}
              </div>
            </div>
          )}
          {location.trim() !== "" && !matchedZone && (
            <div className="sans" style={{fontSize:14,color:C.brownMd}}>{copy.lookupFallback}</div>
          )}
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:18,marginBottom:36}}>
        {SHIPPING_ZONES.map((zone) => (
          <div key={zone.id} style={{background:C.white,borderRadius:20,padding:"20px",border:`1.5px solid ${matchedZone?.id===zone.id ? C.pink : C.paper}`,boxShadow:"0 2px 12px rgba(45,26,46,.05)"}}>
            <div style={{fontSize:18,fontWeight:800,color:C.brown,marginBottom:6}}>{zone.label}</div>
            <div className="sans" style={{fontSize:13,color:C.brownLt,marginBottom:10}}>{zone.days}</div>
            <div className="sans" style={{fontSize:15,fontWeight:800,color:C.pink}}>{zone.displayPrice || (zone.price === 0 ? "Gratis" : `$${zone.price}`)}</div>
          </div>
        ))}
      </div>

      <div style={{background:`linear-gradient(135deg,${C.paper},${C.cream})`,borderRadius:24,padding:"30px 28px",border:`1.5px solid ${C.paper}`}}>
        <h2 className="serif" style={{fontSize:28,marginBottom:16}}>{copy.howTitle}</h2>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:16}}>
          {copy.howSteps.map((step, index) => (
            <div key={index} style={{background:C.white,borderRadius:18,padding:"18px 18px",border:`1.5px solid ${C.paper}`}}>
              <div style={{fontSize:12,fontWeight:800,color:C.pink,marginBottom:8}}>PASO {index + 1}</div>
              <div className="sans" style={{fontSize:14,color:C.brownMd,lineHeight:1.7}}>{step}</div>
            </div>
          ))}
        </div>
        <p className="sans" style={{fontSize:13,color:C.brownLt,marginTop:16}}>{copy.pickupNote}</p>
      </div>
    </div>
  );
}

export { AboutPage, DeliveryPage, HomePage, NavBar, PaymentResultPage, ShopPage };
